<template>
    <div class="Home">
        <div class="container-inner">
            <TitleSection
                title="Welcome"
                text="Wondering how much Life Insurance or Income Protection to get? Find some options using our handy calculators."
            />
            <ul class="Home__options">
                <li class="Home__option">
                    <BigButton
                        title="Life Insurance calculator"
                        alt="Start life insurance calculator"
                        @button-click="$router.push('life')"
                        :icon="life">
                    </BigButton>
                </li>
                <li class="Home__option">
                    <BigButton
                        title="Income Protection calculator"
                        alt="Start income protection calculator"
                        :icon="income"
                        @button-click="$router.push('income')">
                    </BigButton>
                </li>
            </ul>
        </div>
        <slot />
    </div>
</template>

<script>
import BigButton from '../components/buttons/BigButton.vue';
import TitleSection from '../components/TitleSection.vue';
import life from '@/assets/icons/individual.svg';
import income from '@/assets/icons/income.svg';

export default {
    name: 'Home',

    components: {
        BigButton,
        TitleSection
    },

    data() {
        return {
            life,
            income
        };
    }
}
</script>

<style scoped lang="scss">
    .Home__options {
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 0;
        margin-top: 20px;
        list-style: none;

        @media screen and (min-width: 767px) {
            flex-direction: row;
            margin-top: 40px;
        }
    }

    .Home__option {
        margin: 0.75em 0.5em;
        text-align: center;
        color: #333;
        cursor: pointer;

        @media screen and (min-width: 767px) {
            margin: 0.75em 2em;
        }
    }
</style>
